// Shared by ScheduleConfigPanel.js and CalendarEntryEditModal.js — kept in
// its own module (rather than exported from ScheduleConfigPanel.js) so the
// two don't form a circular import (ScheduleConfigPanel.js also imports
// CalendarEntryEditModal.js, to render it).

/**
 * The schedule-type ids that make up a variant group. A group is either a
 * "single" variant (only `single` set) or an A/B "split" variant (`aDay`
 * and/or `bDay` set). Each id is a schedule-type id, or null when that slot
 * is unused.
 */
export interface ScheduleTypeIds {
  single?: number | null;
  aDay?: number | null;
  bDay?: number | null;
}

/** A schedule variant group, keyed by its constituent schedule-type ids. */
export interface ScheduleVariantGroup {
  scheduleTypeIds: ScheduleTypeIds;
}

export function isSplitVariant(
  group: ScheduleVariantGroup | null | undefined
): boolean {
  return Boolean(group?.scheduleTypeIds.aDay || group?.scheduleTypeIds.bDay);
}
